import { ReactElement, useState } from 'react'
import styled from 'styled-components'

import {
  IDraggedLocation,
  ILocationRemove,
  IRoutingProjectPlanModel,
  IRoutingProjectPlanOptimization
} from 'features/RoutingProjects/types'
import { getUniqueColor } from 'utils/style'
import { RouteStops } from 'features/RoutingProjects/components/RoutingProjectSidebar/OptimizedRoutesList/StopsList'

import { AddStopModal } from 'features/RoutingProjects/components/AddStopModal'
import { RouteItemHeader } from 'features/RoutingProjects/components/RoutingProjectSidebar/OptimizedRoutesList/RouteItem/Header'

const RouteItemContainer = styled.li`
  display: grid;
  grid-template-columns: 7px 1fr;
  border: 1px solid #eae9e9;
  border-radius: 8px;
`

const RouteItemFlag = styled.div<{ color: string }>`
  width: 100%;
  height: 100%;
  background-color: ${({ color }): string => color};
  border-radius: 22px 0 0 22px;
`

const Split = styled.div`
  width: calc(100% - 32px);
  margin: auto;
  background-color: #eae9e9;
  height: 1px;
`

const RouteStopsContainer = styled.div`
  padding: 16px;
`

interface IRouteItemProps {
  routingProjectId: string
  route: IRoutingProjectPlanOptimization['routes'][0]
  routeIndex: number
  draggedLocation: IDraggedLocation | null
  onLocationRemove: (args: ILocationRemove) => void
  planModel: IRoutingProjectPlanModel
  setPlanModel: (planModel: IRoutingProjectPlanModel) => void
  currentOptimization: IRoutingProjectPlanOptimization
}

export const RouteItem = ({
  routingProjectId,
  route,
  routeIndex,
  draggedLocation,
  onLocationRemove,
  planModel,
  setPlanModel,
  currentOptimization
}: IRouteItemProps): ReactElement => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(true)
  const [isOpenAddStopModal, setIsOpenAddStopModal] = useState(false)
  const rgbColor = getUniqueColor(routeIndex)

  return (
    <RouteItemContainer>
      <RouteItemFlag color={rgbColor} />
      <div>
        <RouteItemHeader
          routingProjectId={routingProjectId}
          currentOptimizationId={currentOptimization.id}
          route={route}
          isDetailsOpen={isDetailsOpen}
          setIsDetailsOpen={setIsDetailsOpen}
          setIsOpenAddStopModal={setIsOpenAddStopModal}
        />
        {isDetailsOpen && (
          <>
            <Split />
            <RouteStopsContainer>
              <RouteStops
                routeIndex={routeIndex}
                stops={route.stops}
                rgbColor={rgbColor}
                draggedLocation={draggedLocation}
                onLocationRemove={onLocationRemove}
                planModel={planModel}
                currentOptimization={currentOptimization}
              />
            </RouteStopsContainer>
          </>
        )}
      </div>
      {isOpenAddStopModal && (
        <AddStopModal
          routingProjectId={routingProjectId}
          planModel={planModel}
          currentOptimization={currentOptimization}
          routeIndex={routeIndex}
          setPlanModel={setPlanModel}
          closeModal={(): void => setIsOpenAddStopModal(false)}
        />
      )}
    </RouteItemContainer>
  )
}
